import {parseResponse} from "./bn_forms";

$(document).on('click', '.js-comment-stick', function () {
    let that = $(this),
        comment = that.parents('.comment-item'),
        hidden = $('#comments-list').find('.comment-item.hidden'),
        sticky = $('#comments-list').find('.bn_comments__sticky-item'),
        id = comment.attr('id'),
        status = that.data('status'),
        type = that.data('type');

    $.ajax({
        'url': '/comments/stick',
        'type': 'POST',
        'data': {
            id: id,
            status: status,
            type: type
        },
        'dataType': 'json',
        'success': function (response) {
            if (status) {
                sticky.remove();
                hidden.removeClass('hidden');
                comment.addClass('hidden');
            } else {
                sticky.remove();
                hidden.removeClass('hidden');
            }

            parseResponse(response);
            runImgLazyLoad();
        }
    });
})